<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3012_12388)">
      <path
        d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5Z"
        fill="#FE6100"
        stroke="#FE6100"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M8.02487 11.2713C7.41011 11.2713 6.91174 11.7593 6.91174 12.3612C6.91174 12.9632 7.41011 13.4512 8.02487 13.4512C8.63964 13.4512 9.138 12.9632 9.138 12.3612C9.138 11.7593 8.63964 11.2713 8.02487 11.2713Z"
        fill="white"
      />
      <rect
        x="6.91174"
        y="2.55273"
        width="2.22626"
        height="7.97742"
        rx="1.11313"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3012_12388">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>

<style scoped>
  /* Add custom styles if needed */
</style>
